<template>
  <span>
    <BotPageTitle />
    <h3
      :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '' }"
      style="margin-top: 0; margin-bottom: 20px; padding: 0 15px;"
    >
      {{ $t("drawer.units.subitems.liveZillaChannel") }}
    </h3>
    <div style="width: 100%">
      <div class="columnWidth">
        <v-col sm="12">
          <v-row no-gutters>
            <v-col style="padding: 0 20px">
              <md-card>
                <md-card-header
                  class="md-card-header-icon md-card-header-green"
                >
                  <div class="card-icon">
                    <md-icon>settings</md-icon>
                  </div>
                  <h4 class="title">
                    {{ $t("webChannel.generalSettings.title") }}
                  </h4>
                </md-card-header>

                <md-card-content>
                  <form class="form-horizontal" action method="post">
                    <div class="md-layout">
                      <div class="md-layout-item" style="margin: auto;">
                        {{
                          $t(
                            "liveZillaChannel.generalSettings.subitems.enableChannel"
                          )
                        }}
                      </div>
                      <div
                        class="md-layout-item md-form-label md-size-15"
                        style="padding: 0; margin: auto;"
                        :class="{
                          'text-success': configuracoes_gerais.canal,
                          'text-danger': !configuracoes_gerais.canal
                        }"
                      >
                        {{
                          configuracoes_gerais.canal
                            ? $t("commonWords.enabled")
                            : $t("commonWords.disabled")
                        }}
                      </div>
                      <div class="md-layout-item md-size-15">
                        <md-switch
                          v-model="configuracoes_gerais.canal"
                        ></md-switch>
                      </div>
                    </div>
                  </form>
                </md-card-content>
              </md-card>
            </v-col>
          </v-row>
        </v-col>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-button
          class="md-twitter"
          style="display: block; margin-left: auto; margin-right: auto;"
        >
          <span style="color: black">{{ $t("commonWords.save") }}</span>
        </md-button>
      </div>
    </div>
  </span>
</template>
<script>
import BotPageTitle from '@/components/BotPageTitle.vue'
export default {
  components: { BotPageTitle },
  data () {
    return {
      configuracoes_gerais: {
        canal: true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}

.columnWidth {
  float: left;
  width: 50%;
}
@media (max-width: 1239px) {
  .columnWidth {
    float: left;
    width: 100%;
  }
}
</style>
